import { CustomerDeletePrompt } from "../CustomerDelete";
import { RecentInvoices } from "./RecentInvoices";
import { EditCustomer } from "../Edit";
import { CustomerT } from "../../../types";
import React, { useState } from "react";
import { CustomerInfo } from "./CustomerInfo";
import { CustomerHeader } from "./CustomerHeader";
import { OutstandingAmount } from "./OutstandingAmount";
import { IInvoice } from "../../../@types";
import { useUserStore } from "../../../state";
import { isNotAccountant } from "../../../utils/isNotAccountant";
import { useTranslation } from "react-i18next";
import { useCompanyStore } from "../../../state/useCompanyStore";
import { useGetPaymentCurrencyList } from "../../../utils";

interface CustomerDetailsProps {
  customer: CustomerT;
  // @ts-ignore
  data: InvoiceStatsData;
  DrawerOpen: boolean;
  showPrompt: boolean;
  toggleDrawer: () => void;
  setShowPrompt: (show: boolean) => void;
  setIsSidebarOpen: (show: boolean) => void;
  showIsLoading: any;
  hideIsLoading: any;
  handleCreateInvoice: () => void;
}
export const CustomerDetails: React.FC<CustomerDetailsProps> = ({
  customer,
  data,
  DrawerOpen,
  showPrompt,
  toggleDrawer,
  setShowPrompt,
  setIsSidebarOpen,
  showIsLoading,
  hideIsLoading,
  handleCreateInvoice,
}) => {
  const [customerState, setCustomerState] = useState<CustomerT>(customer);
  const { roles } = useUserStore();
  const companyProfile = useCompanyStore();
  const { userCurrencyCode } = useGetPaymentCurrencyList(
    companyProfile.company,
  );

  const handleEditSuccess = (updatedData: CustomerT) => {
    setCustomerState(updatedData);
  };
  const { t } = useTranslation("customer");
  return (
    <>
      <OutstandingAmount
        customer={customer}
        currency={userCurrencyCode.currency}
      />

      {isNotAccountant(roles) && (
        <div className="w-full">
          <CustomerHeader
            handleCreateInvoice={handleCreateInvoice}
            customer={customer}
            toggleDrawer={toggleDrawer}
            setShowPrompt={setShowPrompt}
            setIsSidebarOpen={setIsSidebarOpen}
          />
        </div>
      )}

      <CustomerInfo
        customer={customer}
        data={data}
        currency={userCurrencyCode.currency}
      />
      <RecentInvoices customerId={customer.id as string} />

      <EditCustomer
        showIsLoading={showIsLoading}
        hideIsLoading={hideIsLoading}
        show={DrawerOpen}
        customer={customer}
        customerId={customer.id as string}
        onEditSuccess={handleEditSuccess}
      />
    </>
  );
};
